export default __webpack_public_path__ + "static/media/intp_logo.54730d6e.png";